import React from "react";
import { Navigate, Outlet } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import jwt from "jwt-decode"

export default function PrivateRoute({ component: Component, ...rest }) {
    const token = window.localStorage.getItem("auth_data")
    return token ? <Outlet /> : <Navigate to={"/login"}></Navigate>;
};
